import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  toInteger(value: any): number {
    return parseInt(`${value}`, 10);
  }
  isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value));
  }

  padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2);
    }
    return '';
  }
  parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }

    const dateParts = value.trim().split('-');
    if (
      dateParts.length > 3 ||
      !dateParts.every((part) => this.isNumber(part))
    ) {
      return null;
    }

    const [first, second, third] = dateParts.map((part) => this.toInteger(part));
    return {
      day: dateParts.length === 1 ? first : second,
      month: dateParts.length === 1 ? null : first,
      year: dateParts.length === 3 ? third : null,
    };
  }

  format(date: NgbDateStruct): string {
    let formattedDate = '';
    if (date) {
      const month = this.padNumber(date.month);
      const day = this.padNumber(date.day);
      const year = date.year;
      formattedDate = `${month}-${day}-${year}`;
    }
    return formattedDate;
  }
} 
